import { render, staticRenderFns } from "./ReferralsShowPending.vue?vue&type=template&id=7e7b3fc2"
import script from "./ReferralsShowPending.vue?vue&type=script&lang=js"
export * from "./ReferralsShowPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports